var $92de32a55b057191$exports = {};
$92de32a55b057191$exports = {
    "more": `Veel \xfcksusi`
};


export {$92de32a55b057191$exports as default};
//# sourceMappingURL=et-EE.mjs.map
